import { combineEpics } from 'redux-observable';

import builds from './builds/epics';
import releaseGroups from './project_grouping/epics';
import { fetchAllProjects, pollTasksEpic } from './projects/epics';

const rootEpic = combineEpics(
  builds,
  pollTasksEpic,
  fetchAllProjects,
  releaseGroups,
);

export default rootEpic;
